<div class="sequencing-grid-container">
  <abc-grid
    #abcGrid
    class="sequencing-grid"
    [toolbar]="gridToolbar"
    [height]="'100%'"
    [width]="'100%'"
    [showBorders]="true"
    [showRowLines]="true"
    [showColumnLines]="true"
    [keyExpr]="keyExpr"
    [selection]="{
      mode: 'multiple',
      showCheckBoxesMode: 'none',
    }"
    [setupDefaultLayoutOnInitialization]="false"
    [loadPanel]="{ enabled: false }"
    (onSelectionChanged)="onSelectionChanged($event)"
    (onOptionChanged)="onGridOptionChanged($event)"
    (onContentReady)="onGridContentReady($event)"
  >
  </abc-grid>
</div>
